import { Swiper, Navigation, Scrollbar, Keyboard, Autoplay } from 'swiper';

Swiper.use([Navigation, Scrollbar, Keyboard, Autoplay]);

$(window).on('load resize', function () {
  swipers();
});

const swipers = () => {
  newsSliderSwiper();
};

const newsSliderSwiper = () => {
  return new Swiper('.news-slider__swiper', {
    loop: false,
    spaceBetween: 30,
    slidesPerView: 1.2,
    navigation: {
      nextEl: `.news-slider__swiper__controls__footer__controls__next`,
      prevEl: `.news-slider__swiper__controls__footer__controls__prev`,
    },
    breakpoints: {
      1200: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
    },
  });
};

$(function () {
  window.swipers = [];

  $('.cappendijk__swiper').each(function (index) {
    let id = 'cappendijk__swiper-' + index;
    $(this).attr('id', id);
    let desktopSlides = $(`#${id}`).data('desktopSlides');
    if (!desktopSlides) {
      desktopSlides = 2;
    }
    let desktopTouch = $(`#${id}`).data('desktopTouch');
    if (!desktopTouch) {
      desktopTouch = true;
    } else {
      desktopTouch = false;
    }
    let mobileSlides = $(`#${id}`).data('mobileSlides');
    if (!mobileSlides) {
      mobileSlides = 1;
    }
    let spaceBetween = $(`#${id}`).data('spaceBetween');
    if (!spaceBetween) {
      spaceBetween = 0;
    }
    let autoplay = $(`#${id}`).data('autoplay');
    if (!autoplay) {
      autoplay = 7500;
    }
    let swiper = new Swiper($(`#${id}`).get(0), {
      spaceBetween: $(`#${id}`).data('spaceBetween'),
      slidesPerView: desktopSlides,
      keyboard: true,
      navigation: {
        nextEl: `#${id} .cappendijk__swiper__controls__next`,
        prevEl: `#${id} .cappendijk__swiper__controls__prev`,
      },
      autoplay: {
        delay: autoplay,
      },
      breakpoints: {
        993: {
          slidesPerView: desktopSlides,
          allowTouchMove: desktopTouch,
        },
        0: {
          slidesPerView: mobileSlides,
        },
      },
    });
    $(window).on('load', function () {
      if (swiper.initialized) {
        swiper.update();
      }
    });
    $(window).on('resize', function () {
      if (swiper.initialized) {
        swiper.update();
      }
    });
    window.swipers[id] = swiper;
  });
});
